import * as React from 'react';
import useForceUpdate from './useForceUpdate.js';
function useSyncState(initialValue) {
  const ref = React.useRef(initialValue);
  const forceUpdate = useForceUpdate();
  return [() => ref.current, newValue => {
    ref.current = newValue;
    // re-render
    forceUpdate();
  }];
}
export { useSyncState as default };
//# sourceMappingURL=useSyncState.js.map
